import api from "@/lib/api";

const CHUNK = 1024 * 1024;

export const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
  const r = (Math.random() * 16) | 0; return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
}));

export async function uploadChunked(file, onProgress) {
  const uploadId = uuid();
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
    await api.post("/uploads/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return { upload_id: uploadId, filename: file.name, content_type: file.type || "application/octet-stream", total_chunks: total };
}

export async function uploadMaintenancePhotos(maintenanceId, files, onProgress) {
  const results = [];
  for (let i = 0; i < files.length; i++) {
    const meta = await uploadChunked(files[i], (p) => onProgress?.(Math.round(((i + p / 100) / files.length) * 100)));
    const { data } = await api.post(`/maintenance/${maintenanceId}/photos`, meta);
    results.push(data);
  }
  return results;
}

export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp";
export const isImage = (f) => ["image/jpeg", "image/png", "image/webp"].includes(f.type);
